import axiosPrivate from "./axiosPrivate";

export const getWalletTransactions = async ({ items_per_page, wallet_number_or_uuid }) => {
  const res = await axiosPrivate.get(`customers/wallet-transactions?page=1&items_per_page=${items_per_page}&wallet_number_or_uuid=${wallet_number_or_uuid}`);
  return res.data;
};